import React from 'react'
import pluginWorkspace from '../../../../assets/images/ai-assistant/plugin-workspace.webp'
import Style from './plugin-showcase.module.scss'

const Image = ({ src, priority: _priority, ...props }: any) => (
    <img src={src === '/images/ai-assistant/plugin-workspace.webp' ? pluginWorkspace : src} {...props} />
)

function DashboardIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M5 19V9M12 19V5M19 19v-7M3 19h18" />
        </svg>
    )
}

function PluginIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M8 3v5M16 3v5M6 8h12v3a6 6 0 0 1-6 6v4M9 12h6" />
        </svg>
    )
}

interface AiAssistantPluginShowcaseProps {
    demoOnly?: boolean
    prompt?: string
}

export default function AiAssistantPluginShowcase({ demoOnly = false, prompt }: AiAssistantPluginShowcaseProps) {
    const Root: 'div' | 'section' = demoOnly ? 'div' : 'section'

    return (
        <Root
            className={`${Style['showcase']} ${demoOnly ? Style['demo-only'] : ''}`}
            aria-labelledby={demoOnly ? undefined : 'ai-plugin-showcase-title'}
        >
            <div className={Style['shell']}>
                <div className={Style['copy']}>
                    <span className={Style['eyebrow']}>小果的插件能力</span>
                    <h2 id="ai-plugin-showcase-title">
                        需要什么功能，
                        <br />
                        直接让小果做。
                    </h2>
                    <p>
                        想查销售、看库存、做经营分析，直接在对话里说。小果会使用对应的插件，根据当前店铺的数据帮你查询、分析并整理结果。
                    </p>
                    <div className={Style['planning-note']}>
                        <span aria-hidden="true" />
                        <p>小果只使用当前账号有权限查看的本店数据，不会查询其他店铺。</p>
                    </div>
                </div>

                <div
                    className={Style['board']}
                    role="img"
                    aria-label={
                        prompt
                            ? `向小果提出“${prompt}”后生成经营看板的示意`
                            : '在对话中调用经营看板插件，并基于当前店铺数据显示经营看板的示意'
                    }
                >
                    <div className={Style['demo']} aria-hidden="true">
                        <div className={`${Style['plugin-float']} ${prompt ? Style['plugin-float-prompt'] : ''}`}>
                            <span className={Style['plugin-float-icon']}>
                                <PluginIcon />
                            </span>
                            {prompt ? (
                                <p>
                                    <strong>{prompt}</strong>
                                </p>
                            ) : (
                                <>
                                    <p>
                                        <strong>经营看板插件</strong>
                                        <span>在对话中调用</span>
                                    </p>
                                    <em>当前可用</em>
                                </>
                            )}
                        </div>
                        <svg className={Style['plugin-route']} viewBox="0 0 90 230" fill="none">
                            <path d="M70 4C72 56 24 59 29 116s22 60 4 101" />
                            <path d="m26 207 7 10 9-8" />
                        </svg>

                        <div className={Style['app-frame']}>
                            <Image
                                className={Style['app-image']}
                                src="/images/ai-assistant/plugin-workspace.webp"
                                alt=""
                                width={2560}
                                height={1680}
                                sizes="(min-width: 1280px) 720px, (min-width: 768px) 55vw, calc(100vw - 60px)"
                            />

                            <div className={Style['plugin-tab']}>
                                <span>
                                    <DashboardIcon />
                                </span>
                                <strong>经营看板</strong>
                            </div>

                            <div className={Style['dashboard']}>
                                <div className={Style['dashboard-head']}>
                                    <div>
                                        <span>
                                            <DashboardIcon />
                                        </span>
                                        <p>
                                            <strong>经营看板</strong>
                                            <em>由插件提供</em>
                                        </p>
                                    </div>
                                    <b>
                                        <i />
                                        数据已更新
                                    </b>
                                </div>
                                <div className={Style['dashboard-summary']}>
                                    <span>本月经营概览</span>
                                    <strong>销售稳步增长，经营整体向好</strong>
                                </div>
                                <div className={Style['dashboard-metrics']}>
                                    <div>
                                        <span>销售额</span>
                                        <strong>12.8万</strong>
                                        <em>环比 +18%</em>
                                    </div>
                                    <div>
                                        <span>毛利率</span>
                                        <strong>26.8%</strong>
                                        <em>提升 1.9%</em>
                                    </div>
                                    <div>
                                        <span>新增客户</span>
                                        <strong>86</strong>
                                        <em>环比 +16%</em>
                                    </div>
                                </div>
                                <div className={Style['dashboard-lower']}>
                                    <div className={Style['trend']}>
                                        <p>
                                            <strong>近 6 个月销售趋势</strong>
                                            <span>持续上升</span>
                                        </p>
                                        <div>
                                            <i style={{ height: '38%' }} />
                                            <i style={{ height: '50%' }} />
                                            <i style={{ height: '61%' }} />
                                            <i style={{ height: '69%' }} />
                                            <i style={{ height: '82%' }} />
                                            <i style={{ height: '94%' }} />
                                        </div>
                                    </div>
                                    <div className={Style['next-action']}>
                                        <span>建议先做</span>
                                        <strong>关注 3 项经营机会</strong>
                                        <p>高毛利品类、沉默客户、新客复购</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Root>
    )
}
